import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private readonly _http = inject(HttpClient);

  uploadFile(url: string, file: File, type: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': type || 'application/octet-stream',
    });
    return this._http.put<any>(url, file, { headers });
  }
}
